import {
  clearMetricsSegmentAnonymousId,
  getMetricsSegmentAnonymousId,
  setMetricsSegmentAnonymousId,
} from "@/modules/metrics/segment";

import {
  clearMetricsGoogleAnalyticsClientId,
  getMetricsGoogleAnalyticsClientId,
  setMetricsGoogleAnalyticsClientId,
  clearMetricsGoogleAnalyticsSessionId,
  getMetricsGoogleAnalyticsSessionId,
  setMetricsGoogleAnalyticsSessionId,
} from "@/modules/metrics/google-analytics";
import { moduleFactory } from "@/factories/module";
import { resetPersistentTrackingData } from "@/modules/metrics/common";
import {
  clearMetricsMetadataString,
  getMetricsMetadataString,
  setMetricsMetadataString,
} from "@/modules/metrics/metadata";
import {
  clearMetricsElectronAppInfo,
  getMetricsElectronAppInfo,
  setMetricsElectronAppInfo,
} from "@/modules/metrics/electron-app-info";
export const metricsModule = moduleFactory.create({
  resetTrackingData: resetPersistentTrackingData,
  setSegmentAnonymousId: setMetricsSegmentAnonymousId,
  getSegmentAnonymousId: getMetricsSegmentAnonymousId,
  clearSegmentAnonymousId: clearMetricsSegmentAnonymousId,
  setGoogleAnalyticsClientId: setMetricsGoogleAnalyticsClientId,
  getGoogleAnalyticsClientId: getMetricsGoogleAnalyticsClientId,
  clearGoogleAnalyticsClientId: clearMetricsGoogleAnalyticsClientId,
  setGoogleAnalyticsSessionId: setMetricsGoogleAnalyticsSessionId,
  getGoogleAnalyticsSessionId: getMetricsGoogleAnalyticsSessionId,
  clearGoogleAnalyticsSessionId: clearMetricsGoogleAnalyticsSessionId,
  setMetadataString: setMetricsMetadataString,
  getMetadataString: getMetricsMetadataString,
  clearMetadataString: clearMetricsMetadataString,
  setElectronAppInfo: setMetricsElectronAppInfo,
  getElectronAppInfo: getMetricsElectronAppInfo,
  clearElectronAppInfo: clearMetricsElectronAppInfo,
});
